import { TableCell as MUITableCell } from '@mui/material';
import { twMerge } from 'tailwind-merge';

export const TableBodyCell = ({
  children,
  withBorderBottom,
  className,
  align = 'left',
  ...props
}) => {
  return (
    <MUITableCell
      className={twMerge(
        '!truncate !p-3 !font-normal !text-[16px]/[24px] !text-base-1000 !text-nowrap',
        withBorderBottom ? '!border-b !border-b-base-400' : '!border-none',
        className,
      )}
      align={align}
      {...props}
    >
      {children}
    </MUITableCell>
  );
};
